import { apiClient } from "@/api/base44Client";
import { useQuery } from "@tanstack/react-query";
import { Upload, Download, Trash2, FolderPlus, ListChecks, MessageSquare, UserPlus, UserMinus, FilePlus2, Activity } from "lucide-react";
import { ACTIVITY_LABELS, formatDateTime } from "@/lib/dataroom";

const ICONS = {
  create_deal: FilePlus2, upload: Upload, download: Download, delete_document: Trash2,
  add_folder: FolderPlus, checklist: ListChecks, question: MessageSquare, qa_reply: MessageSquare,
  invite: UserPlus, remove_member: UserMinus,
};

export default function ActivityTab({ deal }) {
  const { data: events = [], isLoading } = useQuery({
    queryKey: ["deal-activity", deal.id],
    queryFn: async () => (await apiClient.get(`/deals/${deal.id}/activity`)).data,
  });

  if (isLoading) return <div className="space-y-2">{[1, 2, 3, 4].map((i) => <div key={i} className="h-12 bg-white rounded-xl animate-pulse" />)}</div>;

  if (events.length === 0) {
    return (
      <div className="text-center py-16 bg-white rounded-2xl border border-slate-200/70">
        <Activity className="w-10 h-10 text-slate-300 mx-auto mb-3" />
        <p className="text-slate-500">Ingen aktivitet ennå</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-2xl border border-slate-200/70 divide-y divide-slate-100">
      {events.map((ev) => {
        const Icon = ICONS[ev.action] || Activity;
        return (
          <div key={ev.id} className="flex items-center gap-3 px-5 py-3">
            <div className="w-9 h-9 rounded-lg bg-slate-100 text-slate-500 flex items-center justify-center shrink-0">
              <Icon className="w-4 h-4" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm text-slate-700">
                <span className="font-semibold text-brand-ink">{ev.actor_name || ev.actor_email}</span>{" "}
                {ACTIVITY_LABELS[ev.action] || ev.action}{ev.target ? ` «${ev.target}»` : ""}
              </p>
            </div>
            <span className="text-xs text-slate-400 shrink-0">{formatDateTime(ev.created_at)}</span>
          </div>
        );
      })}
    </div>
  );
}
